import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { Team } from './components/Team';
import { Testimonials } from './components/Testimonials';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-nova-bone font-sans selection:bg-nova-cyan/30 selection:text-nova-dark" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Services data-id="element-5" />
        <Team data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CtaBanner data-id="element-8" />
        <Contact data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
    </div>;
}